import { render, staticRenderFns } from "./service4.vue?vue&type=template&id=1ab75c3a&scoped=true&"
import script from "./service4.vue?vue&type=script&lang=js&"
export * from "./service4.vue?vue&type=script&lang=js&"
import style0 from "./service4.vue?vue&type=style&index=0&id=1ab75c3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab75c3a",
  null
  
)

export default component.exports